import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueLoading from 'vue-loading-overlay'
import VCalendar from '@komdech/v-calendar'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import VueLoading CSS
import 'vue-loading-overlay/dist/vue-loading.css'

// Import font
import './assets/font/stylesheet.css'

// Import ndbx button style
import './assets/ndbx/dropdownfilter.css'
import './assets/ndbx/select.css'
import './assets/ndbx/input.css'
import './assets/ndbx/radio.css'
import './assets/ndbx/button.css'
import VueExpandableImage from 'vue-expandable-image'

Vue.use(VueExpandableImage)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// User vue loading
Vue.use(VueLoading)
// Use VCalendar
Vue.use(VCalendar)

// Filter Thai bath
Vue.filter('thaiBath', function (value, decimals) {
  if (value !== undefined && value !== null) {
    const num = Number.parseFloat(value)
    if (decimals) {
      return num.toLocaleString('th-TH', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })
    }
    // Display 2 decimals only if value has decimal precision
    if (num % 1 !== 0) {
      return num.toLocaleString('th-TH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    }
    return num.toLocaleString('th-TH')
  } else return 0
})

// Filter Thai date
Vue.filter('thaiDate', function (value) {
  var d = new Date(value),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear() + 543

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('/')
})

/*
 * Thai date time
 */
Vue.filter('thaiDateTime', function (value) {
  if (value) {
    const d = new Date(value)
    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    const year = d.getFullYear() + 543

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    const result = `${[day, month, year].join('/')}  ${d.toLocaleTimeString('th-TH', {
      hour: '2-digit',
      minute: '2-digit',
    })}`
    return result
  } else return 'ไม่ระบุ'
})

Vue.filter('setTextChannel', function (value) {
  if (!value) return 'ไม่ระบุ'
  if (value === 'branch') return 'สาขา'
  if (value === 'direct_branch') return 'แชร์ลิงก์'
})

Vue.config.productionTip = false

/**
 * Axios interceptors
 */
axios.interceptors.request.use(async (config) => {
  const jwtToken = await store.getters['staff/getAccessToken']
  if (jwtToken != null) {
    config.headers.Authorization = 'Bearer ' + jwtToken
  }

  return config
})

/**
 * Axios response interceptors
 */
let isRefreshing = false
let subscribers = []
axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (err) => {
    const {
      config,
      response: { status, data },
    } = err

    const originalRequest = config
    if (config.responseType == 'blob') {
      data.code = 1401
    }
    if (status === 401 && data.code == 1401) {
      if (!isRefreshing) {
        isRefreshing = true
        await store
          .dispatch('staff/refreshToken')
          .then(({ status }) => {
            if (status === 200 || status == 204) {
              isRefreshing = false
            }
            subscribers = []
          })
          .catch(() => {
            console.error('Refresh Token Expired')
            store.dispatch('staff/destroyAuth')
          })
      }

      const requestSubscribers = new Promise((resolve) => {
        subscribeTokenRefresh(() => {
          resolve(axios(originalRequest))
        })
      })

      onRefreshed()

      return requestSubscribers
    }
    return Promise.reject(err)
  }
)

function subscribeTokenRefresh(cb) {
  subscribers.push(cb)
}

function onRefreshed() {
  subscribers.map((cb) => cb())
}

subscribers = []

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
